import './styles.css'

type MenuProps = {
	opened?: Boolean
}

const Menu = ({opened = false}: MenuProps) =>  {
	if(!opened) return (<a href='#to-do' className='menu'><span className='center'>Menu</span></a>);
	else return (<a href='#to-do' className='close-x'>Close</a>);
}


export default Menu;
